export default "/images/vendor/@coreui/icons/svg/flag/cif-sr.svg?f0467deb07eb041f16a4110b85d50011";